/**
 * Turn what a reader has typed into a number the formula engine can use.
 *
 * The field holds a raw string rather than a number so that a half-typed entry
 * is left alone: '-' and '1.' are both on the way to something valid, and a
 * field that erased them as you typed would be unusable. Anything not yet a
 * finite number simply has no value, and the calculator waits.
 *
 * @param raw - The current contents of the field
 * @returns The number, or undefined while the field is empty or incomplete
 */
export const parseInputValue = (raw: string): number | undefined => {
  // Results print with thousands separators, so readers reasonably type them
  // back in. Spaces get the same treatment for pasted figures.
  const cleaned = raw.replaceAll(',', '').replaceAll(' ', '').trim();

  if (cleaned === '') {
    return undefined;
  }

  const parsed = Number(cleaned);

  return Number.isFinite(parsed) ? parsed : undefined;
};
